import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createOrder, verifyOrder, fetchPlans, addPlan, editPlan, deletePlan } from '../thunks/planThunks';

interface Plan {
  id: string;
  name: string;
  price: number;
  features: string[];
  badge?: string;
}

interface order {
    id: string;
    userId: string;
    planName: number;
    planType: string;
    planExpiry: string;
    amount: string;
    currency: string;
    razorpayOrderId: string;
    razorpayPaymentId: string;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    errorMessage: string | null;
  }

interface PlanState {
  order: order[];
  plans: Plan[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  errorMessage: string | null;
}

const initialState: PlanState = {
  order: [],
  plans: [],
  status: 'idle',
  errorMessage: null,
};

const planSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // create-order
      .addCase(createOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createOrder.fulfilled, (state, action: PayloadAction<order[]>) => {
        state.status = 'succeeded';
        state.order = action.payload;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload as string;
      })
      // verify-order
      .addCase(verifyOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(verifyOrder.fulfilled, (state, action: PayloadAction<order[]>) => {
        state.status = 'succeeded';
        state.order = action.payload;
      })
      .addCase(verifyOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload as string;
      })
      // Fetch Plans
      .addCase(fetchPlans.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPlans.fulfilled, (state, action: PayloadAction<Plan[]>) => {
        state.status = 'succeeded';
        state.plans = action.payload;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload as string;
      })

      // Add Plan
      .addCase(addPlan.fulfilled, (state, action: PayloadAction<Plan>) => {
        state.plans.push(action.payload);
      })

      // Edit Plan
      .addCase(editPlan.fulfilled, (state, action: PayloadAction<Plan>) => {
        const index = state.plans.findIndex((plan) => plan.id === action.payload.id);
        if (index !== -1) {
          state.plans[index] = action.payload;
        }
      })

      // Delete Plan
      .addCase(deletePlan.fulfilled, (state, action: PayloadAction<string>) => {
        state.plans = state.plans.filter((plan) => plan.id !== action.payload);
      });
  },
});

export default planSlice.reducer;
